import { render, staticRenderFns } from "./Plcsdata.vue?vue&type=template&id=d8b964dc&scoped=true&"
import script from "./Plcsdata.vue?vue&type=script&lang=js&"
export * from "./Plcsdata.vue?vue&type=script&lang=js&"
import style0 from "./Plcsdata.vue?vue&type=style&index=0&id=d8b964dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b964dc",
  null
  
)

export default component.exports